import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ControlIdentity, CplaceSingleTextControlChange, CplaceSingleTextControlParameters } from '../../../api/model/models';
import { CplaceControlWithEditModeComponent, CPLACE_CONTROL_COMPONENT_VALUE_ACCESSOR } from '../shared';
import { CplaceControlService } from '../shared/cplace-control.service';

@Component({
  selector: 'cf-frontend-sdk-cplace-single-text-control',
  templateUrl: './cplace-single-text-control.component.html',
  styleUrls: ['./styles/cplace-single-text-control.component.scss'],
  providers: [CPLACE_CONTROL_COMPONENT_VALUE_ACCESSOR(CplaceSingleTextControlComponent)],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CplaceSingleTextControlComponent extends CplaceControlWithEditModeComponent<string> {
  public static readonly componentName = 'CplaceSingleTextControlComponent';

  /**
   * Whether the control should use a text area.
   */
  @Input() public isTextArea = false;

  @ViewChild('cplaceSingleTextControlInput', { static: false, read: ElementRef })
  private textInputComponent?: ElementRef;

  @ViewChild('cplaceSingleTextControlTextArea', { static: false, read: ElementRef })
  private textAreaComponent?: ElementRef;

  @HostBinding('class.cf-frontend-sdk-cplace-single-text-control') public cplaceSingleTextControl = true;

  /**
   * Whether the empty value view should be shown.
   */
  public $showEmptyValue: Observable<boolean> = combineLatest([this.$value, this.$editMode]).pipe(
    map(([value, editMode]) => {
      return !value && !editMode;
    })
  );

  constructor(
    public elementRef: ElementRef<HTMLElement>,
    public changeDetectorRef: ChangeDetectorRef,
    public cplaceControlService: CplaceControlService
  ) {
    super(elementRef, changeDetectorRef, cplaceControlService);
  }

  protected initializeControlParameters(controlParameters: CplaceSingleTextControlParameters): void {
    this.value = controlParameters.value;
    this.isTextArea = controlParameters.isTextArea;
  }

  protected beforeSubmitHook(): void {
    this.returnToDefaultState();
  }

  protected onCancelHook(): void {
    this.returnToDefaultState();
  }

  protected getControlChange(identity: ControlIdentity, value: string): CplaceSingleTextControlChange {
    return { featureName: identity.featureName, componentName: CplaceSingleTextControlComponent.componentName, value: value };
  }

  protected getComponentClassName(): string {
    return CplaceSingleTextControlComponent.componentName;
  }

  protected onClear(): void {
    this.value = '';
  }

  private returnToDefaultState() {
    this.textInputComponent?.nativeElement.blur();
    this.textAreaComponent?.nativeElement.blur();
  }
}
